mutation (
  $input: WebMessageInput!
) {
  sendWebMessage(
    input: $input
  )
}
